import React from 'react'; 
import '../styles/PartnerWithUs.css';
import PartnerIntro from '../components/Partnerwithus/PartnerIntro';
import PartnerBannerImage from '../components/Partnerwithus/PartnerBannerImage';
import PartnerQuote from '../components/Partnerwithus/PartnerQuote';
import RedBanner from '../components/Partnerwithus/RedBanner';
import GreyBanner from '../components/Partnerwithus/GreyBanner';
import JoinNowForm from '../components/Partnerwithus/JoinNowForm';
import PartnerNumberGrid from '../components/Partnerwithus/PartnerNumberGrid';
import PartnerMotivationSection from '../components/Partnerwithus/PartnerMotivationSection';
import PartnerMotivationPunchline from '../components/Partnerwithus/PartnerMotivationPunchline';
import PartnerVisualSequence from '../components/Partnerwithus/PartnerVisualSequence';
import PartnerJoinSection from '../components/Partnerwithus/PartnerJoinSection';
import PartnerTestimonial from '../components/Partnerwithus/PartnerTestimonial';


function PartnerWithUs() {
  return (
    <div className='partnerWithUsSection'>
      <PartnerIntro />
      <PartnerBannerImage />
      <PartnerQuote text={`"YES, I'm ready to join you guys!"`} />
      <JoinNowForm />
      <RedBanner text={`We EMPOWER YOU to close more deals with our SUCCESS SALES SYSTEM`} />
      <GreyBanner text={`Join JS PROPERTY, And You'll Find...`} />
      <PartnerNumberGrid />
      <PartnerMotivationSection />
      <PartnerMotivationPunchline />
      <PartnerVisualSequence />
      <PartnerQuote text={`"YES, I'm ready to join you guys!"`} />
      <PartnerJoinSection />
      <PartnerTestimonial />
    </div>
  );
}

export default PartnerWithUs;
